import { useStore } from '@nuxtjs/composition-api'
import { catchError, finalize, from, merge, tap } from 'rxjs'
import useLogout$ from './useLogout$'
import useErrorHandler from './useErrorHandler'

export default function useLogout(context) {
  const store = useStore()

  const { errorHandler$ } = useErrorHandler(context)
  const { logout$ } = useLogout$()

  function logout(afterPath = '/') {
    const username = store.state.authModule.user.username
    merge(from(store.dispatch('startLoading')), logout$(afterPath))
      .pipe(
        tap(() => {
          window.dataLayer &&
            window.dataLayer.push({
              event: 'logoutEvent',
              username: username
            })
        }),
        catchError(err => errorHandler$(err)),
        finalize(() => store.dispatch('completeLoading'))
      )
      .subscribe()
  }

  return {
    logout
  }
}
